import React from 'react';

export interface ContextMenuItemProps {
  onClick: () => void;
  label: string
  icon?: React.ReactNode;
  className?: string
}

const ContextMenuItem: React.FC<ContextMenuItemProps> = ( {
  onClick = () => { return; },
  label,
  icon,
  className = 'hover:bg-gray-300 w-full h-full p-1.5 pr-4 flex items-center gap-x-1'
} ) => {

  return (
    <div className={className} onClick={onClick} >
      { icon }
      <p className='text-sm'>{label}</p>
    </div>
  );
};

export default ContextMenuItem;
